module.exports = __webpack_public_path__ + "media/stylesheets/images/no_image_post-161fcce85c949fe3d7ee8bf5ecfdc270.jpg";